import React from 'react';
import { searchTooltipPropTypes } from './SearchTooltipPropTypes';
import * as styles from './SearchTooltip.module.scss';
const SearchTooltip = ({
  label = 'Znajdź w Google',
  position,
  onClick,
  href,
  open
}) => {
  if (!href && !label && !open) {
    return null;
  }
  return href && open && /*#__PURE__*/React.createElement("div", {
    className: styles.root,
    onClick: onClick,
    style: {
      top: position.top,
      left: position.left
    }
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.rootLink,
    rel: "noreferrer nofollow noopener",
    target: "_blank",
    href: href
  }, label));
};
export default SearchTooltip;